import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "30",
  height: "30",
  fill: "none",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "1.6",
  viewBox: "0 0 30 30"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M5 25.5V5l20.5 20.5z" }, null, -1 /* CACHED */),
    _createElementVNode("path", { d: "M9 21.5V15l6.5 6.5zM5 10h2.5M5 14h2.5M5 18h1.5" }, null, -1 /* CACHED */)
  ]))]))
}
export default { render: render }